import * as React from 'react';
import styled from 'react-emotion';
import { adminReload } from '../store/actions';
import { sendTestCheckIn } from '../store/actions/testActions';
import Button from './Button';

interface AdminControlsProps {
  onToggleAdminControls: () => void;
  show: boolean;
}
interface AdminControlsState {
  disabled: boolean;
  checkInStatus: CheckInStatus;
}
type CheckInStatus = 'none' | 'sending' | 'success' | 'error';

const AdminControlsWrapper = styled('div')`
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  padding-top: 2rem;
  opacity: ${(props: { show: boolean }) => (props.show ? 1 : 0)};
  pointer-events: ${props => (props.show ? 'all' : 'none')};
  transition: opacity 250ms ease-in-out;
`;
const CloseButton = styled(Button)`
  position: absolute;
  top: 0;
  right: 0;
  box-shadow: 0 0 2rem #000;
`;
const AdminReloadButton = styled(Button)`
  box-shadow: 0 0 2rem #000;
  font-size: 2rem;
`;
const AdminTestCheckInButton = styled(Button)`
  box-shadow: 0 0 2rem #000;
  font-size: 2rem;
`;
const AdminDashboardLinkButton = styled(Button)`
  box-shadow: 0 0 2rem #000;
  font-size: 2rem;
`;

const blue = '#46C9E5';
const green = '#9AD5CA';
const pink = '#D26AC2';
const red = '#E80F1D';
const gradient = (from: string, to: string) =>
  `linear-gradient(45deg,${from} 0%, ${to} 100%);`;

class AdminControls extends React.Component<
  AdminControlsProps,
  AdminControlsState
> {
  public initialState: AdminControlsState = {
    checkInStatus: 'none',
    disabled: false,
  };

  constructor(props: AdminControlsProps) {
    super(props);

    this.state = this.initialState;
  }

  public render() {
    const { onToggleAdminControls, show } = this.props;
    const { checkInStatus, disabled } = this.state;
    const checkInBg = (() => {
      switch (checkInStatus) {
        case 'error':
          return gradient(pink, red);
        case 'none':
          return gradient(blue, pink);
        case 'sending':
          return gradient(blue, pink);
        case 'success':
          return gradient(blue, green);
        default:
          return gradient(blue, pink);
      }
    })();
    const checkInText = (() => {
      switch (checkInStatus) {
        case 'error':
          return 'something went wrong.';
        case 'none':
          return 'send a test check-in.';
        case 'sending':
          return 'sending check-in.';
        case 'success':
          return 'sent!';
        default:
          return 'send a test check-in.';
      }
    })();
    const checkInTextEs = (() => {
      switch (checkInStatus) {
        case 'error':
          return 'something went wrong.';
        case 'none':
          return 'send a test check-in (spanish).';
        case 'sending':
          return 'sending check-in.';
        case 'success':
          return 'sent!';
        default:
          return 'send a test check-in (spanish).';
      }
    })();

    return (
      <AdminControlsWrapper show={show}>
        <CloseButton bg={red} onClick={onToggleAdminControls} size="1rem">
          ✖
        </CloseButton>
        <AdminReloadButton
          bg="linear-gradient(45deg,#46C9E5 0%,#D26AC2 100%);"
          disabled={disabled}
          onClick={this.adminReload}>
          clear cache and reload.
        </AdminReloadButton>
        <AdminTestCheckInButton
          bg={checkInBg}
          disabled={disabled}
          onClick={this.adminCheckIn}>
          {checkInText}
        </AdminTestCheckInButton>
        <AdminTestCheckInButton
          bg={checkInBg}
          disabled={disabled}
          onClick={this.adminCheckInEs}>
          {checkInTextEs}
        </AdminTestCheckInButton>
        <AdminDashboardLinkButton
          bg={checkInBg}
          disabled={disabled}
          onClick={this.goToDashboard}>
          Go To Dashboard
        </AdminDashboardLinkButton>
      </AdminControlsWrapper>
    );
  }

  private adminReload = async () => {
    this.setState({ disabled: true });

    await adminReload(true);
  };

  private adminCheckIn = async () => {
    this.setState({ checkInStatus: 'sending', disabled: true });

    const result = await sendTestCheckIn();

    this.setState({
      checkInStatus: result.name ? 'success' : 'error',
      disabled: false,
    });
  };

  private adminCheckInEs = async () => {
    this.setState({ checkInStatus: 'sending', disabled: true });

    const result = await sendTestCheckIn('esp');

    this.setState({
      checkInStatus: result.name ? 'success' : 'error',
      disabled: false,
    });
  };

  private goToDashboard = async () => {
    window.location.href = 'https://just-in.texnrewards.com/check-ins';
  }
}

export default AdminControls;



// WEBPACK FOOTER //
// ./src/components/AdminControls.tsx